<template>
  <CustomDialog
    v-model="dialog"
    ref="customDialog"
    title="Resumo dos ganhos"
    hideFooter
    @cancel="close()"
  >
    <div>
      <div class="text-body-1 mb-4">
        Você já raspou todas as suas raspadinhas, seus itens já estão no seu
        inventário 🎉<br />
        Não pare a diversão, garanta novas raspadinhas e continue jogando!
      </div>

      <v-list class="transparent px-0" nav>
        <v-list-item
          v-for="(item, i) in prizes"
          class="rounded-lg neutral2"
          :key="i"
        >
          <v-list-item-avatar class="mr-2" color="neutral3" rounded="xl">
            <v-img
              :src="
                item.image ||
                (item.type === 'event'
                  ? require(`@/assets/prizes/${item.event}.png`)
                  : require(`@/assets/prizes/${item.type}.png`))
              "
              :aspect-ratio="4 / 4"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ item?.name || "Nada" }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action v-if="item.type === 'item'">
            <v-btn
              class="btn"
              :disabled="loading || used.includes(i)"
              color="primary"
              small
              @click="useItem(item, i)"
            >
              {{ used.includes(i) ? "Usado" : "Usar" }}
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <TokenDialog ref="tokenDialog" :seeMore="false" />
    </div>
  </CustomDialog>
</template>

<script>
import { mapGetters } from "vuex";
import { useItem } from "@/services/items";
import CustomDialog from "@/components/customDialog/CustomDialog";
import TokenDialog from "@/modules/main/partials/tokenDialog/TokenDialog.vue";

export default {
  name: "ScratchResult",

  props: {
    prizes: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    CustomDialog,
    TokenDialog,
  },

  data() {
    return {
      loading: false,
      dialog: false,
      used: [],
    };
  },

  computed: {
    ...mapGetters({ _currentRaffle: "currentRaffle" }),
  },

  methods: {
    async useItem(item, index) {
      if (!this._currentRaffle) return this.$root.$emit("paused-draw");

      try {
        this.loading = true;

        const payload = {
          target: "raffles",
          targetID: this._currentRaffle?._id,
          qty: item.qty,
        };

        const { data } = await useItem(item.item._id, payload);

        this.used.push(index);
        this.$refs.tokenDialog.open(data);

        this.$alert("Item consumido com sucesso", "success");
        this.$root.$emit("load-session");
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading = false;
      }
    },

    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$emit("close");
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
